export { default } from './Hero';

export enum HeroBackground {
  LIGHT_BLUE = 'LIGHT_BLUE',
  DARK_BLUE = 'DARK_BLUE',
  DARK_RED = 'DARK_RED',
  WHITE = 'WHITE',
}

export type HeroSize = 'small' | 'medium' | 'large';

export type HeroTitleVariant = 'accent' | 'divider';

export type HeroContentPosition = 'left' | 'right';
